import * as React from 'react';
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";
export const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className={screen1.screen1__wrapper}>
        <div className="container">

          <HeaderLogoAndTel logo={"white"} phoneColor={"#fff"}/>

          <div className={screen1.screen1__info}>
            <span className={screen1.screen1__subtitle}>Онлайн-курс</span>
            <h1 className={screen1.screen1__title}>Тайм-менеджмент<br/>и повышение эффективности</h1>
            <picture>
              <source srcSet="https://fs.advance.ru/landing-pages/online/time_management/_screen1/firstscreenphoto-320.png" media="(max-width: 767px)"/>
              <source srcSet="https://fs.advance.ru/landing-pages/online/time_management/_screen1/firstscreenphoto.png"/>
              <img src="https://fs.advance.ru/landing-pages/online/time_management/_screen1/firstscreenphoto.png" alt={""}/>
            </picture>
            <p className={screen1.screen1__text}>Пусть время работает на вас, а не против вас</p>
            <a className={main.mainBtn} href="#widget">Начать учиться</a>
          </div>

        </div>
      </div>
    </header>
  );
};
